import { Box } from '@chakra-ui/react';

import ClassicTemplate from '../templates/ClassicTemplate';
import CreativeTemplate from '../templates/CreativeTemplate';
import ModernTemplate from '../templates/ModernTemplate';
import { CVData, CVSettings, CVTemplate } from '../types';

interface CVPreviewProps {
  data: CVData;
  settings: CVSettings;
  template: CVTemplate;
}

const TEMPLATE_MAP = {
  classic: ClassicTemplate,
  modern: ModernTemplate,
  creative: CreativeTemplate,
};

const CVPreview = ({ data, settings, template }: CVPreviewProps) => {
  const TemplateComponent = TEMPLATE_MAP[template] || ClassicTemplate;

  return (
    <Box
      width="100%"
      height="100%"
      overflow="auto"
      backgroundColor="gray.700"
    >
      <Box
        width="100%"
        minHeight="100%"
      >
        <TemplateComponent data={data} settings={settings} />
      </Box>
    </Box>
  );
};

export default CVPreview;
